export const PASSWORD = 'password';
export const ID = 'id';
export const titular = {
  name: 'titular',
  label: 'Titular',
  idName: 'idTitular',
};
export const suscripcion = {
  name: 'suscripcion',
  label: 'Suscripción',
};
export const suscripciones = {
  name: 'suscripciones',
  label: 'Suscripciónes',
};

export const email = {
  name: 'email',
  label: 'Email',
};

export const rol = {
  name: 'rol',
  label: 'Rol',
};
export const correo = {
  name: 'correo',
  label: 'Correo',
};
export const username = {
  name: 'username',
  label: 'Usuario',
};
export const telefono = {
  name: 'telefono',
  label: 'Teléfono',
};
export const password = {
  name: 'password',
  label: 'Contraseña',
};
export const perfil = {
  name: 'perfil',
  label: 'Perfil',
  idName: 'idPerfil',
};

export const foto = {
  name: 'foto',
  label: 'Foto',
};

export const tipoDni = {
  name: 'tipoDni',
  label: 'Tipo documento',
};
export const dni = {
  name: 'dni',
  label: 'Identificación',
};
export const dniEscolar = {
  name: 'dniEscolar',
  label: 'Iden. Escolar',
  quest: '¿Identificación escolar?',
  family: 'Identificación del representante',
};

// estudiantes
export const matricula = {
  name: 'matricula',
  label: 'Matrícula',
};

export const pnombre = {
  name: 'pnombre',
  label: 'Primer nombre',
};
export const snombre = {
  name: 'snombre',
  label: 'Segundo nombre',
};
export const papellido = {
  name: 'papellido',
  label: 'Primer apellido',
};
export const sapellido = {
  name: 'sapellido',
  label: 'Segundo apellido',
};
export const torneos = {
  name: 'torneos',
  label: 'Torneos',
};

export const perfiles = {
  name: 'perfiles',
  label: 'Perfiles',
};

export const genero = {
  name: 'genero',
  label: 'Género',
};
export const tipoSangre = {
  name: 'tipoSangre',
  label: 'Tipo de sangre',
};

export const fechaNacimiento = {
  name: 'fechaNacimiento',
  label: 'Fecha de nacimiento',
};
export const internet = {
  name: 'internet',
  label: 'Internet',
  quest: '¿Tiene internet?',
};
export const actividadExtcur = {
  name: 'actividadExtcur',
  label: 'Actividad extracurricular',
  quest: '¿Tiene alguna Actividad extracurricular?',
};

export const PERFIL = 'perfil';

export const nombre = {
  name: 'nombre',
  label: 'Nombre',
};

export const subtitulo = {
  name: 'subtitulo',
  label: 'Subtitulo',
};

export const estatus = {
  name: 'estatus',
  label: 'Estatus',
  idName: 'idEstatus',
};
export const tasa = {
  name: 'tasa',
  label: 'Tasa',
};
export const entEstatus = {
  name: 'entEstatus',
  label: 'Estatus',
  idName: 'idEntEstatus',
};

export const publico = {
  name: 'publico',
  label: 'Publico',
};

export const prefijo = {
  name: 'prefijo',
  label: 'Prefijo',
};

export const oficio = {
  name: 'oficio',
  label: 'Oficio',
};

export const profesion = {
  name: 'profesion',
  label: 'Profesión',
  idName: 'idProfesion',
};

export const totalUsuarios = {
  name: 'totalUsuarios',
  label: 'Usuarios',
};

export const nroRegistro = {
  name: 'nroRegistro',
  label: 'Nro. Registro',
};

export const usuario = {
  name: 'usuario',
  label: 'Usuario',
};

export const entidad = {
  name: 'entidad',
  label: 'Entidad',
  idName: 'idEntidad',
};
export const entidades = {
  name: 'entidades',
  label: 'Entidades',
};
export const docente = {
  name: 'docente',
  label: 'Docente',
};
export const diasClases = {
  name: 'diasClases',
  label: 'Horario',
};
export const dias = {
  name: 'dias',
  label: 'Dias',
};
export const direccion = {
  name: 'direccion',
  label: 'Direccion',
};
export const tipoEntidad = {
  name: 'tipoEntidad',
  label: 'Tipo de Entidad',
};
export const isAbierto = {
  name: 'isAbierto',
  label: 'Abierto',
  quest: '¿Esta abierto?',
};
export const ESTADO = 'estado';
export const TIPO_ENTIDAD = 'tipoEntidad';
export const TIPO_SANGRE = 'tipoSangre';

export const actions = {
  name: 'actions',
  label: 'Acción',
};

export const abrev = {
  name: 'abrev',
  label: 'Abreviación',
};
export const simbolo = {
  name: 'simbolo',
  label: 'Símbolo',
};
export const start = {
  name: 'start',
  label: 'Inicio',
};
export const end = {
  name: 'end',
  label: 'Final',
};

export const breaking = {
  name: 'break',
  label: 'Libre',
};

export const numero = {
  name: 'numero',
  label: 'Número',
};
export const operadora = {
  name: 'operadora',
  label: 'Operadora',
};
export const isPrincipal = {
  name: 'isPrincipal',
  label: 'Principal',
};
export const fechas = {
  name: 'fechas',
  label: 'Fechas',
};
export const fechaInicio = {
  name: 'fechaInicio',
  label: 'Fecha de inicio',
};
export const fechaFinal = {
  name: 'fechaFinal',
  label: 'Fecha final',
};
export const tema = {
  name: 'tema',
  label: 'Tema',
  idName: 'idTema',
};
export const bloquePedagogico = {
  name: 'bloquePedagogico',
  label: 'Bloque pedagógico',
};
export const periodoAcademico = {
  name: 'periodoAcademico',
  label: 'Período Académico',
  idName: 'idPeriodoAcademico',
};
export const activo = {
  name: 'activo',
  label: 'Activo',
};
export const deporte = {
  name: 'deporte',
  label: 'Deporte',
  idName: 'idDeporte',
};
export const ronda = {
  name: 'ronda',
  label: 'Ronda',
  idName: 'idRonda',
};
export const jugadores = {
  name: 'jugadores',
  label: 'Jugadores',
};
export const jugador = {
  name: 'jugador',
  label: 'Jugador',
};
export const lider = {
  name: 'lider',
  label: 'Líder',
  idName: 'idLider',
};
export const tipo = {
  name: 'tipo',
  label: 'Tipo',
};
export const entrenador = {
  name: 'entrenador',
  label: 'Entrenador',
};

export const seccion = {
  name: 'seccion',
  label: 'Sección',
  idName: 'idSeccion',
};
export const modulo = {
  name: 'modulo',
  label: 'Módulo',
  idName: 'idModulo',
};
export const capacidad = {
  name: 'capacidad',
  label: 'Capacidad',
};
export const equipos = {
  name: 'equipos',
  label: 'Equipos',
  tag: 'Cantidad de equipos',
};
export const lugar = {
  name: 'lugar',
  label: 'Lugar',
};
export const grupos = {
  name: 'grupos',
  label: 'Grupos',
};
export const turno = {
  name: 'turno',
  label: 'Turno',
};
export const nota = {
  name: 'nota',
  label: 'Nota',
};
export const totalMatriculas = {
  name: 'totalMatriculas',
  label: 'Matrículas',
};

export const hasta = {
  name: 'hasta',
  label: 'Hasta',
};
export const desde = {
  name: 'desde',
  label: 'Desde',
};

export const nivelAcademico = {
  name: 'nivelAcademico',
  label: 'Nivel Académico',
  idName: 'idNivelAcademico',
};
export const categoria = {
  name: 'categoria',
  label: 'Categoría',
};
export const siglas = {
  name: 'siglas',
  label: 'Siglas',
};
export const tipoNivelAcademico = {
  name: 'tipoNivelAcademico',
  label: 'Tipo de Nivel',
};

export const carrera = {
  name: 'carrera',
  label: 'Carrera',
  idName: 'idCarrera',
};
export const carreras = {
  name: 'carreras',
  label: 'Carreras',
};
export const codigo = {
  name: 'codigo',
  label: 'Código',
};
export const rif = {
  name: 'rif',
  label: 'RIF',
};
export const code = {
  name: 'code',
  label: 'Código',
};
export const totalEntidades = {
  name: 'totalEntidades',
  label: 'Entidades',
};
export const modalidad = {
  name: 'modalidad',
  label: 'Modalidad',
};
export const totalSecciones = {
  name: 'totalSecciones',
  label: 'Secciones',
};
export const totalDocentes = {
  name: 'totalDocentes',
  label: 'Docentes',
};
export const totalMaterias = {
  name: 'totalMaterias',
  label: 'Materias',
};

export const link = {
  name: 'link',
  label: 'Link',
};
export const route = {
  name: 'route',
  label: 'Enrutamiento',
};
export const alias = {
  name: 'alias',
  label: 'Alias',
};
export const icon = {
  name: 'icon',
  label: 'Icono',
};
export const imagen = {
  name: 'imagen',
  label: 'Imagén',
};
export const referencia = {
  name: 'referencia',
  label: 'Referencia',
  pay: 'Referencia de pago',
};
export const desc = {
  name: 'desc',
  label: 'Descripción',
};
export const descEstatus = {
  name: 'descEstatus',
  label: 'Descripción',
};
export const materia = {
  name: 'materia',
  label: 'Materia',
  idName: 'idMateria',
};
export const temaIndispensable = {
  name: 'temaIndispensable',
  label: 'Tema indispensable',
};
export const temaGenerador = {
  name: 'temaGenerador',
  label: 'Tema generador',
};
export const fechaBloque = {
  name: 'fechaBloque',
  label: 'Fecha del bloque pedagógico',
  idName: 'idFechaBloque',
};

export const entrada = {
  name: 'entrada',
  label: 'Entrada',
};
export const salida = {
  name: 'salida',
  label: 'Salida',
};
export const segEntrada = {
  name: 'segEntrada',
  label: 'Seguridad de entrada',
};
export const segSalida = {
  name: 'segSalida',
  label: 'Seguridad de salida',
};

export const todos = {
  name: 'todos',
  label: 'Todos',
};
export const costo = {
  name: 'costo',
  label: 'Costo',
};
export const monto = {
  name: 'monto',
  label: 'Monto',
};
export const moneda = {
  name: 'moneda',
  label: 'Moneda',
  idName: 'idMoneda',
};
export const oficial = {
  name: 'oficial',
  label: 'Oficial',
};
export const cambio = {
  name: 'cambio',
  label: 'Cambio',
  idName: 'idCambio',
};
export const fecha = {
  name: 'fecha',
  label: 'Fecha',
  tag: 'Fecha de inicio',
};
export const equipo = {
  name: 'equipo',
  label: 'Equipo',
};
export const resultado = {
  name: 'resultado',
  label: 'Resultado',
};
export const ganador = {
  name: 'ganador',
  label: 'Ganador',
};
export const juego = {
  name: 'juego',
  label: 'Juego',
};
export const fechaHora = {
  name: 'fechaHora',
  label: 'Fecha y Hora',
  tag: 'Fecha de inicio',
};
export const horario = {
  name: 'horario',
  label: 'Horario',
};
export const concepto = {
  name: 'concepto',
  label: 'Concepto',
};
export const conceptos = {
  name: 'conceptos',
  label: 'Conceptos',
};
export const total = {
  name: 'total',
  label: 'Total',
};
export const fechaTope = {
  name: 'fechaTope',
  label: 'Fecha tope',
};
export const fechaPago = {
  name: 'fechaPago',
  label: 'Fecha de cancelado',
};
export const fechaVerificado = {
  name: 'fechaVerificado',
  label: 'Fecha de verificado',
};
export const fechaEstatus = {
  name: 'fechaEstatus',
  label: 'Fecha de estatus',
};
export const tipoPago = {
  name: 'tipoPago',
  label: 'Tipo de pago',
};
export const image = {
  name: 'image',
  label: 'Imagen',
};

export const asistencias = {
  name: 'asistencias',
  label: 'Asistencias',
};
export const inasistencias = {
  name: 'inasistencias',
  label: 'Inasistencias',
};
export const horarios = {
  name: 'horarios',
  label: 'Horarios',
};
export const totalAsistencias = {
  name: 'totalAsistencias',
  label: 'Total de asistencias',
};

export const titulo = {
  name: 'titulo',
  label: 'Título',
};
export const evaluaciones = {
  name: 'evaluaciones',
  label: 'Evaluaciones',
};
export const evaluacion = {
  name: 'evaluacion',
  label: 'Evaluación',
  idName: 'idEvaluacion',
};
export const actividades = {
  name: 'actividades',
  label: 'Actividades académicas',
};
export const actividad = {
  name: 'actividad',
  label: 'Actividad',
};
export const instrumento = {
  name: 'instrumento',
  label: 'Instrumento',
  idName: 'idInstrumento',
};

export const dia = {
  name: 'dia',
  label: 'Dia',
};
export const num = {
  name: 'num',
  label: 'Número',
};

export const horas = {
  name: 'horas',
  label: 'Horas',
};

export const aprobado = {
  name: 'aprobado',
  label: 'Aprobado',
};

export const ponderacion = {
  name: 'ponderacion',
  label: 'Ponderación',
  ajustes: 'Punto de aprobación para las actividades evaluativas',
};
export const competencia = {
  name: 'competencia',
  label: 'Competencia',
  ajustes: 'Punto máximo de competencia a evaluar',
};
export const mesesMorosidad = {
  name: 'mesesMorosidad',
  label: 'Meses de morosidad',
  ajustes: 'Cantidad de meses de morosidad',
};
export const minutosAcademicos = {
  name: 'minutosAcademicos',
  label: 'Minutos académicos',
  ajustes: 'Cantidad de minutos académicos',
};
export const bloquesPedagogicos = {
  name: 'bloquesPedagogicos',
  label: 'Bloque pedagógico',
  ajustes: 'Cantidad de bloques pedagógico',
};

export const isOperativo = {
  name: 'isOperativo',
  label: 'Operativo',
  quest: '¿Esta operativo?',
};
export const aula = {
  name: 'aula',
  label: 'Aula',
  idName: 'idAula',
};

export const pais = {
  name: 'pais',
  label: 'País',
};
export const estado = {
  name: 'estado',
  label: 'Estado',
};
export const ciudad = {
  name: 'ciudad',
  label: 'Ciudad',
  idName: 'idCiudad',
};
export const latitud = {
  name: 'latitud',
  label: 'Latitud',
};
export const longitud = {
  name: 'longitud',
  label: 'Longitud',
};

export const grupo = {
  name: 'grupo',
  label: 'Grupo',
};
export const color = {
  name: 'color',
  label: 'Color',
};

export const horaInicio = {
  name: 'horaInicio',
  label: 'Hora de inicio',
};
export const horaFinal = {
  name: 'horaFinal',
  label: 'Hora de final',
};
export const posicion = {
  name: 'posicion',
  label: 'Posición',
};
export const inicio = {
  name: 'inicio',
  label: 'Inicio',
};
export const final = {
  name: 'final',
  label: 'Final',
};
export const inicioHora = {
  name: 'inicioHora',
  label: 'Hora de inicio',
};
export const fin = {
  name: 'fin',
  label: 'Fin',
};
export const finHora = {
  name: 'finHora',
  label: 'Hora final',
};

export const read = {
  name: 'read',
  label: 'Leer',
};
export const create = {
  name: 'create',
  label: 'Crear',
};
export const update = {
  name: 'update',
  label: 'Editar',
};
export const deleted = {
  name: 'delete',
  label: 'Eliminar',
};
export const report = {
  name: 'report',
  label: 'Reportar',
};
export const isInicio = {
  name: 'isInicio',
  label: 'Inicio',
};
export const vista = {
  name: 'vista',
  label: 'Vista',
  idName: 'idVista',
};
export const totalDias = {
  name: 'totalDias',
  label: 'Días',
  quest: 'Total de días disponibles',
};
export const totalBloques = {
  name: 'totalBloques',
  label: 'Bloques',
  quest: 'Total de bloques por minutos académicos',
};

export const temasAcademicos = {
  name: 'temasAcademicos',
  label: 'Temas académicos',
};
